import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import _ from 'lodash';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const SHOP_API_URL = `${API_HOST}/api/shop`;
const SHOP_API_STORE_CONFIGURATION_SETTING_URL = `${SHOP_API_URL}/storeConfigurationSetting`;

function* createShopMenu() {
  yield takeEvery(actions.CREATE_SHOP_MENU, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/menu`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SHOP_MENU_ENDED });
    }
  });
}

function* searchShopMenus() {
  yield takeEvery(actions.SEARCH_SHOP_MENUS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/menu?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SHOP_MENUS_ENDED });
    }
  });
}

function* updateShopMenu() {
  yield takeEvery(actions.UPDATE_SHOP_MENU, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/menu`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_MENU_ENDED });
    }
  });
}

function* deleteShopMenus() {
  yield takeEvery(actions.DELETE_SHOP_MENUS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/menu`, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_SHOP_MENUS_END });
    }
  });
}

function* createShopMenuShopMerchandises() {
  yield takeEvery(actions.CREATE_SHOP_MENU_SHOP_MERCHANDISES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/menuMerchandise`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SHOP_MENU_SHOP_MERCHANDISES_ENDED });
    }
  });
}

function* getStoreIdsRelatedToShopMenu() {
  yield takeEvery(actions.GET_STORES_IDS_RELATED_TO_SHOP_MENU, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/menu/getStoreIdsRelatedToShopMenu`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_STORES_IDS_RELATED_TO_SHOP_MENU_ENDED });
    }
  });
}

function* searchShopMenuShopMerchandises() {
  yield takeEvery(actions.SEARCH_SHOP_MENU_SHOP_MERCHANDISES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/menuMerchandise?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_SHOP_MENU_SHOP_MERCHANDISES_ENDED });
    }
  });
}

function* deleteShopMenuShopMerchandises() {
  yield takeEvery(actions.DELETE_SHOP_MENU_SHOP_MERCHANDISES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/menuMerchandise`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_SHOP_MENU_SHOP_MERCHANDISES_ENDED });
    }
  });
}

function* createAdditionalShopMerchandises() {
  yield takeEvery(actions.CREATE_ADDITIONAL_SHOP_MERCHANDISE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/additionalMerchandise`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_ADDITIONAL_SHOP_MERCHANDISE_ENDED });
    }
  });
}

function* searchAdditionalShopMerchandises() {
  yield takeEvery(actions.SEARCH_ADDITIONAL_SHOP_MERCHANDISES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/additionalMerchandise?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_ADDITIONAL_SHOP_MERCHANDISES_ENDED });
    }
  });
}

function* deleteAdditionalMerchandises() {
  yield takeEvery(actions.DELETE_ADDITIONAL_SHOP_MERCHANDISES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/additionalMerchandise`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_ADDITIONAL_SHOP_MERCHANDISES_ENDED });
    }
  });
}

function* searchShopCategories() {
  yield takeEvery(actions.SEARCH_SHOP_CATEGORIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/category?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_SHOP_CATEGORIES_ENDED });
    }
  });
}

function* updateShopCategories() {
  yield takeEvery(actions.UPDATE_SHOP_CATEGORIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/category`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_CATEGORIES_ENDED });
    }
  });
}

function* createMerchandiseSpec() {
  yield takeEvery(actions.CREATE_MERCHANDISE_SPEC, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/merchandise/spec`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_MERCHANDISE_SPEC_END });
    }
  });
}

function* updateMerchandiseSpec() {
  yield takeEvery(actions.UPDATE_MERCHANDISE_SPEC, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/merchandise/spec`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_MERCHANDISE_SPEC_END });
    }
  });
}

function* deleteMerchandiseSpecs() {
  yield takeEvery(actions.DELETE_MERCHANDISE_SPECS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/merchandise/spec`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MERCHANDISE_SPECS_END });
    }
  });
}

function* searchMerchandiseSpecs() {
  yield takeEvery(actions.SEARCH_MERCHANDISE_SPECS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/merchandise/spec/?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_MERCHANDISE_SPECS_END });
    }
  });
}

function* findMerchandiseSpec() {
  yield takeEvery(actions.FIND_MERCHANDISE_SPEC, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/merchandise/spec/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_MERCHANDISE_SPEC_END });
    }
  });
}

function* searchMerchandises() {
  yield takeEvery(actions.SEARCH_MERCHANDISES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/merchandise?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_MERCHANDISES_ENDED });
    }
  });
}

function* findMerchandise() {
  yield takeEvery(actions.FIND_MERCHANDISE, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/merchandise/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_MERCHANDISE_ENDED });
    }
  });
}

function* createMerchandise() {
  yield takeEvery(actions.CREATE_MERCHANDISE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/merchandise`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_MERCHANDISE_ENDED });
    }
  });
}

function* deleteMerchandises() {
  yield takeEvery(actions.DELETE_MERCHANDISES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/merchandise`, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_MERCHANDISES_ENDED });
    }
  });
}

function* createMerchandiseItem() {
  yield takeEvery(actions.CREATE_MERCHANDISE_ITEM, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/merchandise/item`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_MERCHANDISE_ITEM_END });
    }
  });
}

function* updateMerchandiseItem() {
  yield takeEvery(actions.UPDATE_MERCHANDISE_ITEM, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/merchandise/item`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_MERCHANDISE_ITEM_END });
    }
  });
}

function* deleteMerchandiseItems() {
  yield takeEvery(actions.DELETE_MERCHANDISE_ITEMS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/merchandise/item`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MERCHANDISE_ITEMS_END });
    }
  });
}

function* searchMerchandiseItems() {
  yield takeEvery(actions.SEARCH_MERCHANDISE_ITEMS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/merchandise/item/?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_MERCHANDISE_ITEMS_END });
    }
  });
}

function* findMerchandiseItem() {
  yield takeEvery(actions.FIND_MERCHANDISE_ITEM, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/merchandise/item/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_MERCHANDISE_ITEM_END });
    }
  });
}

function* updateMerchandise() {
  yield takeEvery(actions.UPDATE_MERCHANDISE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/merchandise`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_MERCHANDISE_ENDED });
    }
  });
}

function* getShopMainConfiguration() {
  yield takeEvery(actions.GET_SHOP_MAIN_CONFIGURATION, function* (action) {
    try {
      const { onSuccess } = action;
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/configuration/main`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_SHOP_MAIN_CONFIGURATION_ENDED });
    }
  });
}

function* updateShopMainConfiguration() {
  yield takeEvery(actions.UPDATE_SHOP_MAIN_CONFIGURATION, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/configuration/main`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_MAIN_CONFIGURATION_ENDED });
    }
  });
}

function* searchShopBrandConfigurations() {
  yield takeEvery(actions.SEARCH_SHOP_BRAND_CONFIGURATIONS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/configuration/brand?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SHOP_BRAND_CONFIGURATIONS_ENDED });
    }
  });
}

function* updateShopBrandConfiguration() {
  yield takeEvery(actions.UPDATE_SHOP_BRAND_CONFIGURATION, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/configuration/brand`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_BRAND_CONFIGURATION_ENDED });
    }
  });
}

function* createShopBrandConfiguration() {
  yield takeEvery(actions.CREATE_SHOP_BRAND_CONFIGURATION, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/configuration/brand`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SHOP_BRAND_CONFIGURATION_ENDED });
    }
  });
}

function* searchShopOrders() {
  yield takeEvery(actions.SEARCH_SHOP_ORDERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/order?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SHOP_ORDERS_ENDED });
    }
  });
}

function* shopOrderRefund() {
  yield takeEvery(actions.SHOP_ORDER_REFUND, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/order/refund`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SHOP_ORDER_REFUND_ENDED });
    }
  });
}

function* shopOrderRefundByManually() {
  yield takeEvery(actions.SHOP_ORDER_REFUND_BY_MANUALLY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/order/manuallyRefund`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SHOP_ORDER_REFUND_BY_MANUALLY_ENDED });
    }
  });
}

function* shopOrderPartiallyRefund() {
  yield takeEvery(actions.SHOP_ORDER_PARTIALLY_REFUND, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/order/partiallyRefund`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SHOP_ORDER_PARTIALLY_REFUND_ENDED });
    }
  });
}

function* copyShopMenu() {
  yield takeEvery(actions.COPY_SHOP_MENU, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/menu/copy`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.COPY_SHOP_MENU_ENDED });
    }
  });
}

function* createShopPointDiscountRule() {
  yield takeEvery(actions.CREATE_SHOP_POINT_DISCOUNT_RULE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/pointDiscountRule`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SHOP_POINT_DISCOUNT_RULE_ENDED });
    }
  });
}

function* searchShopPointDiscountRules() {
  yield takeEvery(actions.SEARCH_SHOP_POINT_DISCOUNT_RULES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/pointDiscountRule?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SHOP_POINT_DISCOUNT_RULES_ENDED });
    }
  });
}

function* deleteShopPointDiscountRules() {
  yield takeEvery(actions.DELETE_SHOP_POINT_DISCOUNT_RULES, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/pointDiscountRule?`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_SHOP_POINT_DISCOUNT_RULES_ENDED });
    }
  });
}

function* findSchedulePromotionalActivity() {
  yield takeEvery(actions.FIND_SCHEDULED_PROMOTIONAL_ACTIVITY, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/promotionalActivity/scheduled/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED });
    }
  });
}

function* searchSchedulePromotionalActivities() {
  yield takeEvery(actions.SEARCH_SCHEDULED_PROMOTIONAL_ACTIVITIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/promotionalActivity/scheduled?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SCHEDULED_PROMOTIONAL_ACTIVITIES_ENDED });
    }
  });
}

function* createSchedulePromotionalActivity() {
  yield takeEvery(actions.CREATE_SCHEDULED_PROMOTIONAL_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SHOP_API_URL}/promotionalActivity/scheduled`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED });
    }
  });
}

function* updateSchedulePromotionalActivity() {
  yield takeEvery(actions.UPDATE_SCHEDULED_PROMOTIONAL_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${SHOP_API_URL}/promotionalActivity/scheduled`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED });
    }
  });
}

function* deleteSchedulePromotionalActivities() {
  yield takeEvery(actions.DELETE_SCHEDULED_PROMOTIONAL_ACTIVITIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/promotionalActivity/scheduled`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_SCHEDULED_PROMOTIONAL_ACTIVITIES_ENDED });
    }
  });
}

function* findMemberTicketPromotionalActivity() {
  yield takeEvery(actions.FIND_MEMBER_TICKET_PROMOTIONAL_ACTIVITY, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/promotionalActivity/memberTicket/${id}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED });
    }
  });
}

function* searchMemberTicketPromotionalActivities() {
  yield takeEvery(actions.SEARCH_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/promotionalActivity/memberTicket?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES_ENDED });
    }
  });
}

function* createMemberTicketPromotionalActivity() {
  yield takeEvery(actions.CREATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SHOP_API_URL}/promotionalActivity/memberTicket`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED });
    }
  });
}

function* updateMemberTicketPromotionalActivity() {
  yield takeEvery(actions.UPDATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${SHOP_API_URL}/promotionalActivity/memberTicket`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED });
    }
  });
}

function* deleteMemberTicketPromotionalActivities() {
  yield takeEvery(actions.DELETE_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'delete'],
        `${SHOP_API_URL}/promotionalActivity/memberTicket`,
        { data: formData },
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES_ENDED });
    }
  });
}

function* findShopMerchandiseCategory() {
  yield takeEvery(actions.FIND_SHOP_MERCHANDISE_CATEGORY, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/merchandiseCategory/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_SHOP_MERCHANDISE_CATEGORY_ENDED });
    }
  });
}

function* searchShopMerchandiseCategories() {
  yield takeEvery(actions.SEARCH_SHOP_MERCHANDISE_CATEGORIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/merchandiseCategory?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SHOP_MERCHANDISE_CATEGORIES_ENDED });
    }
  });
}

function* updateShopMerchandiseCategory() {
  yield takeEvery(actions.UPDATE_SHOP_MERCHANDISE_CATEGORY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/merchandiseCategory`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_MERCHANDISE_CATEGORY_ENDED });
    }
  });
}

function* deleteShopMerchandiseCategories() {
  yield takeEvery(actions.DELETE_SHOP_MERCHANDISE_CATEGORIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/merchandiseCategory`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_SHOP_MERCHANDISE_CATEGORIES_ENDED });
    }
  });
}

// Sales quantity limit
function* getSalesQuantityLimit() {
  yield takeEvery(actions.GET_SALES_QUANTITY, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/saleLimits/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_SALES_QUANTITY_ENDED });
    }
  });
}

function* searchSalesQuantityLimit() {
  yield takeEvery(actions.SEARCH_SALES_QUANTITY, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/saleLimits?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SALES_QUANTITY_ENDED });
    }
  });
}

function* createSalesQuantityLimit() {
  yield takeEvery(actions.CREATE_SALES_QUANTITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/saleLimits`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
      yield put({ type: actions.CREATE_SALES_QUANTITY_ENDED });
    }
  });
}

function* updateSalesQuantityLimit() {
  yield takeEvery(actions.UPDATE_SALES_QUANTITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/saleLimits`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
      yield put({ type: actions.UPDATE_SALES_QUANTITY_ENDED });
    }
  });
}

function* deleteSalesQuantityLimit() {
  yield takeEvery(actions.DELETE_SALES_QUANTITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/saleLimits`, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    }
  });
}
// Sales quantity limit end

function* getShopOrderExtraColumnKey() {
  yield takeEvery(actions.GET_SHOP_ORDER_EXTRA_COLUMN_KEY, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SHOP_API_URL}/shopOrderExtraColumnKey/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_SHOP_ORDER_EXTRA_COLUMN_KEY_END });
    }
  });
}

function* searchShopOrderExtraColumnKeys() {
  yield takeEvery(actions.SEARCH_SHOP_ORDER_EXTRA_COLUMN_KEYS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_URL}/shopOrderExtraColumnKey?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SHOP_ORDER_EXTRA_COLUMN_KEYS_END });
    }
  });
}

function* createShopOrderExtraColumnKey() {
  yield takeEvery(actions.CREATE_SHOP_ORDER_EXTRA_COLUMN_KEY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/shopOrderExtraColumnKey`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
      yield put({ type: actions.CREATE_SHOP_ORDER_EXTRA_COLUMN_KEY_END });
    }
  });
}

function* updateShopOrderExtraColumnKey() {
  yield takeEvery(actions.UPDATE_SHOP_ORDER_EXTRA_COLUMN_KEY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SHOP_API_URL}/shopOrderExtraColumnKey`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
      yield put({ type: actions.UPDATE_SHOP_ORDER_EXTRA_COLUMN_KEY_END });
    }
  });
}

function* deleteShopOrderExtraColumnKey() {
  yield takeEvery(actions.DELETE_SHOP_ORDER_EXTRA_COLUMN_KEY, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SHOP_API_URL}/shopOrderExtraColumnKey${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
      yield put({ type: actions.DELETE_SHOP_ORDER_EXTRA_COLUMN_KEY_END });
    }
  });
}

function* retryShopOrderRefund() {
  yield takeEvery(actions.RETRY_SHOP_ORDER_REFUND, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SHOP_API_URL}/order/retryRefund`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    }
  });
}

function* searchStoreConfigurationSettings() {
  yield takeEvery(actions.SEARCH_STORE_CONFIGURATION_SETTINGS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_STORE_CONFIGURATION_SETTINGS_ENDED });
    }
  });
}

function* getWeekdayServiceSettings() {
  yield takeEvery(actions.GET_WEEKDAY_SERVICE_SETTINGS, function* (action) {
    const { storeId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/weekdayService/${storeId}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_WEEKDAY_SERVICE_SETTINGS_ENDED });
    }
  });
}

function* updateWeekdayServiceSetting() {
  yield takeEvery(actions.UPDATE_WEEKDAY_SERVICE_SETTING, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/weekdayService`,
        parameters,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_WEEKDAY_SERVICE_SETTING_ENDED });
    }
  });
}

function* getSuspendServiceSetting() {
  yield takeEvery(actions.GET_SUSPEND_SERVICE_SETTING, function* (action) {
    const { storeId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/suspendService/${storeId}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SUSPEND_SERVICE_SETTING_ENDED });
    }
  });
}

function* getTodayServiceStatus() {
  yield takeEvery(actions.GET_TODAY_SERVICE_STATUS, function* (action) {
    const { storeId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/todayServiceStatus/${storeId}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_TODAY_SERVICE_STATUS_ENDED });
    }
  });
}

function* updateShopStoreTodayServiceStatus() {
  yield takeEvery(actions.UPDATE_SHOP_STORE_TODAY_SERVICE_STATUS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/todayServiceStatus`,
        parameters,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_STORE_TODAY_SERVICE_STATUS_ENDED });
    }
  });
}

function* createShopStoreSuspendServiceSetting() {
  yield takeEvery(actions.CREATE_SHOP_STORE_SUSPEND_SERVICE_SETTING, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/suspendService`,
        parameters,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED });
    }
  });
}

function* updateShopStoreSuspendServiceSetting() {
  yield takeEvery(actions.UPDATE_SHOP_STORE_SUSPEND_SERVICE_SETTING, function* (action) {
    const { id, parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/suspendService/${id}`,
        parameters,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED });
    }
  });
}

function* deleteShopStoreSuspendServiceSetting() {
  yield takeEvery(actions.DELETE_SHOP_STORE_SUSPEND_SERVICE_SETTING, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'delete'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/suspendService/${id}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED });
    }
  });
}

function* getShopStoreHolidayServiceSettings() {
  yield takeEvery(actions.GET_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS, function* (action) {
    const { storeId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/holidayService/${storeId}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS_ENDED });
    }
  });
}

function* deleteShopStoreHolidayServiceSettings() {
  yield takeEvery(actions.DELETE_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'delete'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/holidayService`,
        { data: formData },
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS_ENDED });
    }
  });
}

function* createShopStoreHolidayServiceSetting() {
  yield takeEvery(actions.CREATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/holidayService`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING_ENDED });
    }
  });
}

function* updateShopStoreHolidayServiceSetting() {
  yield takeEvery(actions.UPDATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING, function* (action) {
    const { formData, onSuccess } = action;
    const { id } = formData;

    try {
      const res = yield call(
        [axios, 'put'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/holidayService/${id}`,
        _.omit(formData, ['id']),
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING_ENDED });
    }
  });
}

function* getShopStoreReplenishTimeServiceSetting() {
  yield takeEvery(actions.GET_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING, function* (action) {
    const { id, onSuccess } = action;

    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/extraService/${id}/replenishTime`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING_ENDED });
    }
  });
}

function* updateShopStoreReplenishTimeServiceSetting() {
  yield takeEvery(actions.UPDATE_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING, function* (action) {
    const { formData, onSuccess } = action;
    const { id } = formData;

    try {
      const res = yield call(
        [axios, 'put'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/extraService/${id}/replenishTime`,
        _.omit(formData, ['id']),
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING_ENDED });
    }
  });
}

function* getShopStoreOverMinutesTimeServiceSetting() {
  yield takeEvery(actions.GET_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING, function* (action) {
    const { id, onSuccess } = action;

    try {
      const res = yield call(
        [axios, 'get'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/extraService/${id}/overMinutes`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING_ENDED });
    }
  });
}

function* updateShopStoreOverMinutesTimeServiceSetting() {
  yield takeEvery(actions.UPDATE_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING, function* (action) {
    const { id, formData, onSuccess } = action;

    try {
      const res = yield call(
        [axios, 'put'],
        `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/extraService/${id}/overMinutes`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING_ENDED });
    }
  });
}

function* searchShopStoreMerchandisesAvailableStatusSettings() {
  yield takeEvery(
    actions.SEARCH_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS,
    function* (action) {
      const { id, parameters, onSuccess } = action;

      try {
        const res = yield call(
          [axios, 'get'],
          `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/merchandises/availableStatus/${id}/?${parameters.toString()}`,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({ type: actions.SEARCH_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS_ENDED });
      }
    },
  );
}

function* updateShopStoreMerchandisesAvailableStatusSettings() {
  yield takeEvery(
    actions.UPDATE_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS,
    function* (action) {
      const { id, formData, onSuccess } = action;

      try {
        const res = yield call(
          [axios, 'put'],
          `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/merchandises/availableStatus/${id}`,
          formData,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({ type: actions.UPDATE_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS_ENDED });
      }
    },
  );
}

function* searchShopStoreMerchandisesItemsStockStatusSettings() {
  yield takeEvery(
    actions.SEARCH_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS,
    function* (action) {
      const { id, parameters, onSuccess } = action;

      try {
        const res = yield call(
          [axios, 'get'],
          `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/merchandisesItems/stockStatus/${id}/?${parameters.toString()}`,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({
          type: actions.SEARCH_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS_ENDED,
        });
      }
    },
  );
}

function* updateShopStoreMerchandisesItemsStockStatusSettings() {
  yield takeEvery(
    actions.UPDATE_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS,
    function* (action) {
      const { id, formData, onSuccess } = action;

      try {
        const res = yield call(
          [axios, 'put'],
          `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/merchandisesItems/stockStatus/${id}`,
          formData,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({
          type: actions.UPDATE_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS_ENDED,
        });
      }
    },
  );
}

function* searchShopStoreMerchandiseItemSpecOptionStockSettings() {
  yield takeEvery(
    actions.SEARCH_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS,
    function* (action) {
      const { id, parameters, onSuccess } = action;

      try {
        const res = yield call(
          [axios, 'get'],
          `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/merchandisesItemSpecOptions/stockStatus/${id}/?${parameters.toString()}`,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({
          type: actions.SEARCH_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS_ENDED,
        });
      }
    },
  );
}

function* updateShopStoreMerchandiseItemSpecOptionStockSettings() {
  yield takeEvery(
    actions.UPDATE_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS,
    function* (action) {
      const { id, formData, onSuccess } = action;

      try {
        const res = yield call(
          [axios, 'put'],
          `${SHOP_API_STORE_CONFIGURATION_SETTING_URL}/merchandisesItemSpecOptions/stockStatus/${id}`,
          formData,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({
          type: actions.UPDATE_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS_ENDED,
        });
      }
    },
  );
}

export default function* rootSaga() {
  yield all([
    fork(createShopMenu),
    fork(searchShopMenus),
    fork(updateShopMenu),
    fork(deleteShopMenus),
    fork(createShopMenuShopMerchandises),
    fork(getStoreIdsRelatedToShopMenu),
    fork(searchShopMenuShopMerchandises),
    fork(deleteShopMenuShopMerchandises),
    fork(createAdditionalShopMerchandises),
    fork(searchAdditionalShopMerchandises),
    fork(deleteAdditionalMerchandises),
    fork(searchShopCategories),
    fork(updateShopCategories),
    fork(createMerchandiseSpec),
    fork(updateMerchandiseSpec),
    fork(searchMerchandiseSpecs),
    fork(deleteMerchandiseSpecs),
    fork(findMerchandiseSpec),
    fork(searchMerchandises),
    fork(findMerchandise),
    fork(createMerchandiseItem),
    fork(updateMerchandiseItem),
    fork(searchMerchandiseItems),
    fork(deleteMerchandiseItems),
    fork(findMerchandiseItem),
    fork(createMerchandise),
    fork(deleteMerchandises),
    fork(updateMerchandise),
    fork(updateShopMainConfiguration),
    fork(getShopMainConfiguration),
    fork(updateShopBrandConfiguration),
    fork(searchShopBrandConfigurations),
    fork(createShopBrandConfiguration),
    fork(searchShopOrders),
    fork(shopOrderRefund),
    fork(shopOrderRefundByManually),
    fork(shopOrderPartiallyRefund),
    fork(copyShopMenu),
    fork(createShopPointDiscountRule),
    fork(searchShopPointDiscountRules),
    fork(deleteShopPointDiscountRules),
    fork(searchSchedulePromotionalActivities),
    fork(findSchedulePromotionalActivity),
    fork(createSchedulePromotionalActivity),
    fork(updateSchedulePromotionalActivity),
    fork(deleteSchedulePromotionalActivities),
    fork(searchMemberTicketPromotionalActivities),
    fork(findMemberTicketPromotionalActivity),
    fork(createMemberTicketPromotionalActivity),
    fork(updateMemberTicketPromotionalActivity),
    fork(deleteMemberTicketPromotionalActivities),
    fork(findShopMerchandiseCategory),
    fork(searchShopMerchandiseCategories),
    fork(updateShopMerchandiseCategory),
    fork(deleteShopMerchandiseCategories),
    fork(getSalesQuantityLimit),
    fork(createSalesQuantityLimit),
    fork(deleteSalesQuantityLimit),
    fork(searchSalesQuantityLimit),
    fork(updateSalesQuantityLimit),
    fork(retryShopOrderRefund),
    fork(getShopOrderExtraColumnKey),
    fork(searchShopOrderExtraColumnKeys),
    fork(createShopOrderExtraColumnKey),
    fork(updateShopOrderExtraColumnKey),
    fork(deleteShopOrderExtraColumnKey),
    fork(searchStoreConfigurationSettings),
    fork(getWeekdayServiceSettings),
    fork(updateWeekdayServiceSetting),
    fork(getSuspendServiceSetting),
    fork(getTodayServiceStatus),
    fork(updateShopStoreTodayServiceStatus),
    fork(createShopStoreSuspendServiceSetting),
    fork(updateShopStoreSuspendServiceSetting),
    fork(deleteShopStoreSuspendServiceSetting),
    fork(getShopStoreHolidayServiceSettings),
    fork(deleteShopStoreHolidayServiceSettings),
    fork(createShopStoreHolidayServiceSetting),
    fork(updateShopStoreHolidayServiceSetting),
    fork(getShopStoreReplenishTimeServiceSetting),
    fork(updateShopStoreReplenishTimeServiceSetting),
    fork(getShopStoreOverMinutesTimeServiceSetting),
    fork(updateShopStoreOverMinutesTimeServiceSetting),
    fork(searchShopStoreMerchandisesAvailableStatusSettings),
    fork(updateShopStoreMerchandisesAvailableStatusSettings),
    fork(searchShopStoreMerchandisesItemsStockStatusSettings),
    fork(updateShopStoreMerchandisesItemsStockStatusSettings),
    fork(searchShopStoreMerchandiseItemSpecOptionStockSettings),
    fork(updateShopStoreMerchandiseItemSpecOptionStockSettings),
  ]);
}
